import TNTControlBase from '../../util/TNTControlBase';

class ServiceAssignmentRulesController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'service_assignment_rules'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default ServiceAssignmentRulesController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/service_assignment_rules.controller.js